import { AppBar, AppBarClasses } from 'react-admin';
import MyUserMenu from './MyUserMenu';

const appBarSx = {
  [`&.${AppBarClasses.appBar} .${AppBarClasses.toolbar}`]: {
    backgroundColor: 'white',
    color: 'black',
  },
  [`& .${AppBarClasses.menuButton}`]: {
    color: 'black',
  },
  [`& .${AppBarClasses.title}`]: {
    textIndent: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};

const MyAppBar = props => {
  const { module } = props;
  return (
    <AppBar {...props} sx={appBarSx} userMenu={<MyUserMenu module ={module}/>}>
    </AppBar>
  );
};

export default MyAppBar;